import React, {useContext} from 'react';
// import {CookieConsent} from 'components/CookieConsent';
// import CookieConsent from 'components/CookieConsent/CookieConsent';
import useCookieConsent from 'components/CookieConsent/useCookieConsent';

const ConsentContext = React.createContext({});

function ConsentProvider(props) {
  const {children} = props;
  const consent = useCookieConsent();
  const {showBanner} = consent;

  return (
    <ConsentContext.Provider value={{consentBanner: showBanner}}>
      {children}
      {/* <CookieConsent {...consent} /> */}
    </ConsentContext.Provider>
  );
}

const useConsent = () => useContext(ConsentContext);

export {ConsentContext, ConsentProvider, useConsent};
